'use client';

import { tv } from 'tailwind-variants';

import { Button } from '@/components/ui/button/button.component';

const partnerButtonKnowMoreStyles = tv({
  slots: {
    container: ['w-fit text-sm'],
  },
});

export default function PartnerShowAddress(props: React.HTMLAttributes<HTMLButtonElement>) {
  const { container } = partnerButtonKnowMoreStyles();

  const { className } = props;

  const goToAboutMeSection = () => {
    const element = document.querySelector('#about') as HTMLElement;
    const offset = 80;

    if (!element) {
      return;
    }

    window.scrollTo({
      top: element.offsetTop - offset,
      behavior: 'smooth',
    });
  };

  return (
    <Button
      variant="text"
      className={container({ className })}
      onClick={goToAboutMeSection}
      data-analytics-event={props?.['data-analytics-event']}
    >
      Ver endereço
    </Button>
  );
}
